<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:43:06
 * @LastEditTime: 2022-11-24 09:53:43
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/list.vue
 *
-->
<template>
  <div class="trial_products_warpper">
    <div class="trial_products_header">
      <img
        alt=""
        class="backimg"
        src="@/assets/images/trialProductsList/back.png"
        @click.stop="goBack"
      />
      <span @click="showActivityRules(true)">活动规则</span>
    </div>
    <p class="my_trial" @click="gopage()">我的试用</p>
    <!-- TODO -->

    <div class="banner_bg"></div>
    <!-- 试用商品列表组件 -->
    <productsList></productsList>
    <!-- 广告轮播图 -->
    <banner></banner>
    <!-- 测评列表 -->
    <evaluationList></evaluationList>

    <!-- 活动规则弹窗 -->
    <van-dialog
      v-model="showRules"
      className="activity_rules"
      confirmButtonText="我知道了"
      getContainer="#app"
    >
      <p class="title">活动规则</p>
      <p class="content">
        什么是好物福利社<br />
        这里是星妈会为用户提供的免费试用福利，我们会发布各种新品优品供大家免费试用，鼓励大家发布真实的体验感受，帮助其他用户更好的了解产品！
        <br />
        <br />
        如何写出优质评价<br />
        1、图片≥3张，文案≥30字，如果有视频，视频≥30秒<br />
        2、平台尊重原创，请会员撰写真实的测评感受，给到诚挚的分享<br />
        3、文案要求丰富有内容:从包装外观、卖点理解、试用感受等方面撰写个人真实感受，文案排列整齐主次分明，给人清晰的阅读体验<br />
        4、为避免侵犯肖像权，参与0元使用活动中露出清晰人脸等个人信息的晒图将不被推荐。建议在不影响美观度的情况下，可在<br />
        5、图片上使用适当的特效进行遮挡<br />
        6、图片清晰无第三方平台水印<br />
        7、不可以出现订单截图<br />
        <br />
        <br />

        活动须知<br />
        1、活动结束后3个工作日内，赢得免单资格的会员将收到短信提示，会员也可以前往“好物福利社-我的试用-已中奖”查看活动状态。<br />
        2、奖品发放成功后3个工作日内，用户请尽快使用，过期则中奖无效。<br />
        3、活动结束后7个工作日内，该期入选的优质评价将在“好物福利社-优质测评”中公示。<br />
        3、用户申请试用后，我们会根据用户针对各个商品的任务完成情况，星妈会日常签到、活跃情况，用户平时的消费情况决定中签用户，并将中签结果展示在“我的申请”中通知大家。
        简单来说完成任务越多，星妈会连续签到、活跃时间长，越容易中间！<br />
        4、同一会员在同一期活动中仅获得一次试用资格。<br />
        5、同一终端设备、同一支付账号、同一注册手机号、同一微信账号、同一收货地址或其他合理显示为同一会员自然人的情形，均视为同一会员。<br />
        6、本活动仅对星妈会会员开放。<br />
        7、本活动最终解释权归星妈会所有。<br />
      </p>
    </van-dialog>
  </div>
</template>
<script>
//组件
import productsList from '@/components/contents/trialProductsList/productsList/index.vue'
import evaluationList from '@/components/contents/trialProductsList/evaluationList/index.vue'
import banner from './module/banner.vue' // banner组件

// 方法
import {
  fomatterNum,
  getCookie,
  isUserEdit,
  isUserLogin,
  getUrlParamsByName,
} from '@/assets/js/common.js'
import { freetrialClick } from '@/utils/freetrialClick.js'

export default {
  name: 'trialProducts',
  data() {
    return {
      userInfo: {},
      show: false,
      editFlagTip: false,
      showRules: false, // 显示活动规则
    }
  },
  components: {
    productsList,
    evaluationList,
    banner,
  },
  activated() {
    this.wxShare()
    // this.$store.commit('changeIncludes', [
    //   'trialProductsIndex',
    //   'trialProducts',
    // ])
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('changeIncludes', ['trialProducts'])
    next()
  },
  created() {
    this.initPage()
  },

  mounted() {
    this.wxShare()
  },

  methods: {
    isUserLogin,
    fomatterNum,
    // 页面初始化
    initPage() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.wxShare()
    },
    //分享
    wxShare() {
      var shareDataParams = {
        shareLink: location.href.split('#')[0],
        shareDesc: '来做星妈品鉴官，无门槛免费体验多款优选产品～',
        shareTitle: '0元试用，免费申请',
        imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
      }
      this.wxJsSet.wxShare('fx', shareDataParams, this)
    },
    getExpertbanner() {
      this.$http.get(
        '/expert/poster/getExpertPoster',
        { crmId: (this.userInfo && this.userInfo.crm_id) || '' },
        (res) => {
          if (res.code == '200' && res.data.url) {
            this.bannerUrl = res.data.url
          }
        }
      )
    },
    goBack() {
      // share_source, 链接包含share_source，表示分享出去的
      if (getUrlParamsByName('share_source')) {
        this.$router.replace('/home')
        console.log('isShare分享回到主页')
      } else {
        if (window.history.length > 1 && getCookie('fromPath')) {
          this.$router.go(-1)
          console.log('子页面回退')
        } else {
          this.$router.replace('/home')
          console.log('回到主页')
        }
      }
    },
    // 查看活动规则
    showActivityRules(onOff) {
      this.showRules = onOff
    },
    // 跳转我的试用列表
    gopage() {
      freetrialClick({ xmhh5_Freetrial_pageclick: '我的试用' })
      this.$router.push('/myTrial')
    },
  },
}
</script>
<style lang="less" scoped>
.trial_products_warpper {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  padding: 16px 12px 36px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 0 -5px;

  .trial_products_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;

    .backimg {
      width: 19px;
      height: 19px;
    }
  }

  .banner_bg {
    width: 100%;
    height: 154px;
    margin: -12px 0 12px 0;
    background: url('../../../assets/images/trialProductsList/banner_bg2.png')
      no-repeat center center;
    background-size: 309px auto;
  }

  .my_trial {
    position: absolute;
    top: 74px;
    right: 0;
    padding: 5px 3px;
    background: #ffffff;
    border-radius: 6px 0px 0px 6px;
    font-size: 12px;
    font-weight: 500;
    color: #fc626b;
    line-height: 16px;
    letter-spacing: 2px;
    writing-mode: tb-rl;
  }
}
</style>

<style lang="less">
.activity_rules {
  width: 304px;
  height: 394px;
  box-sizing: border-box;
  padding: 44px 14px 20px 25px;
  background: url('../../../assets/images/trialProductsList/ActivityRulesBg.png')
      no-repeat left top,
    #fff;
  background-size: 100% auto;

  .title {
    font-size: 17px;
    color: #333333;
    line-height: 24px;
    margin-bottom: 16px;
    text-align: center;
  }

  .content {
    height: 222px;
    overflow: auto;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-bottom: 21px;
  }

  .van-dialog__footer {
    width: 152px;
    height: 45px;
    margin: 0 auto;
  }

  .van-dialog__confirm {
    height: 45px;
    background: linear-gradient(90deg, #fe7079 0%, #fc656f 100%);
    border-radius: 100px;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
